import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";
import App from "./app";

// ----------------------------------------------------------------------

Sentry.init({
  dsn: "https://dc6133e0f4b3449d1e7ff287719f3059@o4511494826229760.ingest.de.sentry.io/4511494829834320",

  environment: import.meta.env.VITE_APP_VERSION,
  release: import.meta.env.VITE_APP_VERSION || "local",

  sendDefaultPii: true,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  tracesSampleRate: 0.1,

  // Normál sessionökből csak kevés replay
  replaysSessionSampleRate: 0.02,

  // Hibánál mindig legyen replay
  replaysOnErrorSampleRate: 1.0,
});

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container #app not found");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
